import Team from './Team';
import moment from 'moment';

export default class TeamMemberRelation {
    constructor() {
        this.role = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const memberRelation = new TeamMemberRelation();
        memberRelation.id = data.id;
        memberRelation.role = data.role;
        memberRelation.team = Team.fromData(data.team);
        memberRelation.start = moment(data.start, 'DD.MM.YYYY');
        memberRelation.end = data.end !== null ? moment(data.end, 'DD.MM.YYYY') : null;
        memberRelation.isTeamViewable = data.isTeamViewable;

        Object.seal(memberRelation);
        return memberRelation;
    }

    toData() {
        return {
            id: this.id,
            team: this.team,
            role: this.role,
            start: this.start.format('DD.MM.YYYY'),
            end: this.end === null ? null : this.end.format('DD.MM.YYYY'),
        };
    }

    isEmpty() {
        return !this.start && !this.end && !this.role && !this.team;
    }

    isValid() {
        if (!this.team) {
            return false;
        }

        if (!this.start) {
            return false;
        }

        if (this.end && moment(this.start, 'DD.MM.YYYY') > moment(this.end, 'DD.MM.YYYY')) {
            return false;
        }

        return true;
    }

    formattedEnd() {
        return this.end === null ? null : this.end.format('DD.MM.YYYY');
    }
}
